(() => {
  const bindPhotoWall = (wall) => {
    if (wall.dataset.photoWallBound === 'true') return;
    wall.dataset.photoWallBound = 'true';
    const photos = [...wall.querySelectorAll('.mb2b-capability-summary__photo')];
    const close = () => {
      wall.classList.remove('is-expanded');
      photos.forEach((photo) => { photo.classList.remove('is-active'); photo.setAttribute('aria-pressed', 'false'); });
    };
    photos.forEach((photo) => photo.addEventListener('click', () => {
      if (photo.classList.contains('is-active')) { close(); return; }
      photos.forEach((item) => { const active = item === photo; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
      wall.classList.add('is-expanded');
    }));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && wall.classList.contains('is-expanded')) close(); });
  };
  document.querySelectorAll('.mb2b-capability-summary__photo-wall').forEach(bindPhotoWall);
})();
